export const SET_SEARCH_STRING = 'SET_SEARCH_STRING'

// Unusable
export const GET_SEARCH_STRING = 'GET_SEARCH_STRING'
